import RankImage from "@/components/RankImages";
import VersatileLink from "@/components/VersatileLink";
import styles from "@/styles/Card.module.scss";
import classnames from "classnames";
import Image from "next/legacy/image";
import { useMemo } from "react";

export default function CardArtwork({
  active,
  index,
  focusIndex,
  rank,
  item,
  className,
  href,
  linkAttr = {},
  intersect = true,
  showValuePlanLabel = false,
}) {
  const url = item.thumbnailUrl;
  const progress =
    (parseInt(item.resume_point, 10) / parseInt(item.duration, 10)) * 100 || 0;
  const viewProgressBar = useMemo(() => {
    const resumePoint = item?.resume_point || 0;
    const duration = item?.duration || 0;
    return resumePoint > 0 && duration > 0;
  }, [item]);
  const viewRank = useMemo(() => {
    return rank && !(focusIndex === index) && active;
  }, [rank, focusIndex, index, active]);
  const viewInactiveRank = useMemo(() => {
    return rank && !active;
  }, [rank, active]);
  const artwork = (
    <div
      className={classnames(styles.artwork, className, {
        [styles.ranking]: rank,
      })}
      aria-label={item.name}
      tabIndex={0}
      role="link"
    >
      {viewRank && (
        <div className={styles.rankingImage}>
          <RankImage rank={rank}></RankImage>
        </div>
      )}

      {viewInactiveRank && (
        <div className={styles.rankingImage}>
          <RankImage rank={rank}></RankImage>
        </div>
      )}

      <div className={styles.inner}>
        <div className={styles.image}>
          {intersect && !!url && (
            <Image
              src={url}
              alt={item.name}
              layout="fill"
              objectFit="contain"
            />
          )}
        </div>
        {viewProgressBar && (
          <div className={styles.progress}>
            <span className={styles["progress-bar"]}>
              <span
                role="presentation"
                className={styles["progress-completed"]}
                style={{ width: `${progress}%` }}
              />
            </span>
          </div>
        )}
      </div>
    </div>
  );
  if (href) {
    return (
      <VersatileLink href={href} {...linkAttr}>
        {artwork}
      </VersatileLink>
    );
  } else {
    return artwork;
  }
}
